import {Column, Entity, PrimaryColumn} from "typeorm";

@Entity("droga")
export class Droga {
  @PrimaryColumn()
  id?: string
  @Column()
  nome?: string
  @Column()
  descricao?: string
  @Column()
  observacao?: string
  @Column()
  excluido?: boolean

}
